import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {icJWT_Account, IncidentRecord, PendingChangeList} from "../../../NIBINInterface";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DataChangeRequestService} from "../../../services/DataChangeRequest.service";
import {AuthService} from "../../../services/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DialogService} from "../../../services/dialog.service";
import Swal from "sweetalert2";
import {DownloadService} from "../../../services/download.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-detail-change-view',
  templateUrl: './detail-change-view.component.html',
  styleUrls: ['./detail-change-view.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers:[DataChangeRequestService,DownloadService]
})
export class DetailChangeViewComponent implements OnInit {
  user: icJWT_Account = <icJWT_Account>{};
  @Input('PendingList') PendingList:PendingChangeList[] = []
  @Input('EditList') EditList:any[] = []
  @Output('RefreshTrigger') RefreshTrigger = new EventEmitter<boolean>();

  displayedColumns: string[] = ['ChangeID','ItemType','ReqDate','ReqLab','AssignedLab'];
  dataSource:any[] = [];
  expandedElement: PendingChangeList | null = null;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild("dialog") dialogTarget!: ElementRef;
  constructor(private authService: AuthService,private dataChangeRequestService:DataChangeRequestService ,private downloadService: DownloadService, private dialogService: DialogService, private router: Router) {
    this.user = this.authService.getUser()
  }

  ngOnInit(): void {
    this.dataSource =this.PendingList;
  }

  SQLPropertyFancy(name: any):string{
    switch (name) {
      case 'Lab':
        return 'Lab'
      case 'OccurrenceDate':
        return 'Occurrence Date'
      case 'SubmissionDate':
        return 'Submission Date'

      default:
        return name
    }
  }

  ProcessChange(ChangeID: string, approved: boolean) {
    this.dataChangeRequestService.ProcessChangeRequest(ChangeID,approved).then((r)=>{
      let msg:string = ""
      if(approved)
        msg = "The Change Request has been Approved."
      else
        msg = "The Change Request has been Rejected."

      Swal.fire({
        icon: 'success',
        title: 'System Notification',
        text: msg,
        timerProgressBar:true,
        timer:5000
      })

      //On Approve or Deny Refresh The List
      this.dataChangeRequestService.GetPendingChangesList(this.user.CurrentDept).then((r)=>{
        this.PendingList = this.dataChangeRequestService.parseChangeList(r.AnyData)
        this.dataSource = this.PendingList;
        this.RefreshTrigger.emit(true)
      })
    })



  }

  PDFViewChange(change: PendingChangeList) {
    const IncidentIDs : Set<string> = new Set<string>()
    if(change.Changes){
      for(let c of change.Changes){
        if(c.IncidentID)
          IncidentIDs.add(c.IncidentID)
      }
    }

    for (let IncidentID of IncidentIDs){
      this.downloadService.DownloadBallisticsReport(IncidentID)
    }
    //


  }

  ViewEdit(change: any) {
    console.log(change)
    this.router.navigateByUrl('/dashboard/review/'+change.IncidentID+'/'+change.ChangeBatchID, { skipLocationChange: true })
  }
}
